import './thirdsec.css';

export default function ThirdSec() {
    return (
        <section className="section3-container">
            {/* Header */}
            <div className="header">
                <h1 className="heading">FEATURES</h1>
                <div className="pagination">1 — 4</div>
            </div>
        </section>
            );
}